import { useTranslate } from 'hooks/useTranslate';
import { useParams } from 'react-router-dom';

import Page from 'modules/_shared/components/Pages/Page';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import OperationDetailsNavigationButtons from './components/OperationDetailsNavigationButtons';
import { useOperationDetailsPage } from './context/OperationDetailsPageContext';
import OperationDetailsPageBody from './components/OperationDetailsPageBody';

import './OperationDetails.scss';

const OperationDetails = () => {
  const { t } = useTranslate();
  const { transactionId: operationId } = useParams();

  const { data } = useOperationDetailsPage();

  return (
    <Page>
      <PageListHeader
        subTitle={t('Transaction')}
        subTitleSuffix={`#${operationId}`}
        actions={[
          <OperationDetailsNavigationButtons />,
          <GoBackButton key="backButton" />,
        ]}
      />

      <OperationDetailsPageBody />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default OperationDetails;
